module.exports = __webpack_public_path__ + "plane-twilight-neon.99d35a247ee79e11dbb4.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/assets/img/plane-twilight-neon.svg
// module id = ../../../../../src/assets/img/plane-twilight-neon.svg
// module chunks = main